import { numericalControlVariableDefinition } from 'libs/end-to-end/src/control-variable-definition-factory';
import { numericalTraitDefinition } from 'libs/end-to-end/src/control-variable-definition-factory';

export const getAdditionalPerformanceFocusAreaControlVariableDefinitions = ({
  preferredMetricDisplayName,
  preferredMetricColumnHeaderValue,
}: {
  preferredMetricDisplayName: string | null;
  preferredMetricColumnHeaderValue: string | null;
}) => {
  return [
    numericalControlVariableDefinition({
      columnHeaderValue: 'experience',
      displayName: 'Experience',
      numericalTraitDefinition: numericalTraitDefinition({
        unitPlural: 'years',
        unitSingular: 'year',
        denominator: 1,
      }),
      description:
        'Refers to the number of years an employee has worked in the industry.',
    }),
    numericalControlVariableDefinition({
      columnHeaderValue: 'tenure',
      displayName: 'Tenure',
      numericalTraitDefinition: numericalTraitDefinition({
        unitPlural: 'years',
        unitSingular: 'year',
        denominator: 1,
      }),
      description:
        'Tenure refers to the length of time an employee has worked with their current organization.',
    }),
    numericalControlVariableDefinition({
      columnHeaderValue: 'job_level',
      displayName: 'Job Level',
      numericalTraitDefinition: numericalTraitDefinition({
        unitPlural: 'levels',
        unitSingular: 'level',
        denominator: 1,
      }),
      description:
        'Job Level refers to an employee’s position or rank within the organizational hierarchy.',
    }),
    numericalControlVariableDefinition({
      columnHeaderValue: 'job_tenure',
      displayName: 'Job Tenure',
      numericalTraitDefinition: numericalTraitDefinition({
        unitPlural: 'years',
        unitSingular: 'year',
        denominator: 1,
      }),
    }),
    numericalControlVariableDefinition({
      columnHeaderValue: `job_avg_${preferredMetricColumnHeaderValue ?? 'perf_review'}`,
      displayName: `Average ${preferredMetricDisplayName ?? 'Performance Review'}`,
      numericalTraitDefinition: numericalTraitDefinition({
        unitPlural: 'units',
        unitSingular: 'unit',
        denominator: 1,
      }),
      description:
        'Job Tenure refers to the length of time an employee has worked in their current role or position.',
    }),
  ];
};

export const getAdditionalHiringFocusAreaControlVariableDefinitions = () => {
  return [
    numericalControlVariableDefinition({
      columnHeaderValue: 'experience',
      displayName: 'Experience',
      numericalTraitDefinition: numericalTraitDefinition({
        unitPlural: 'years',
        unitSingular: 'year',
        denominator: 1,
      }),
    }),
  ];
};
